import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faClipboard, faFileArrowUp, faFile, faFileZipper, faLaughWink, faSignOutAlt, faBoxArchive, faFileExport, faClipboardCheck, faClipboardList, faEnvelopeOpenText, faGears, faSliders, faUsers, faBuilding, faClipboardQuestion, faGavel, faWallet, faChartPie, faChartColumn, faChartLine, faAddressCard, faRegistered, faCreditCard, faCalculator, faClockRotateLeft, faThumbTack, faThumbTackSlash, faT, faTags, faDoorOpen, faArchive } from '@fortawesome/free-solid-svg-icons';
import './sideMenu.css'
import SideMenuItem from './SideMenuItem';
import { resetUser } from '../../../slice/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import ModalContainer from '../modal-container/ModalContainer';
import LogoFNMA from "../../../asset/img/FNMA.svg";

const SideMenu = () => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state)=>state.user);
//   const profile = useSelector((state)=>state.profile.userProfile);
//   const companiesList = useSelector((state) => state.generalSetting.companiesList);

  const menuItems = [
    {
      name: "Utenti",
      icon: faUsers,
      roles: ["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"],
      path: "/users",
      match: "users",
    },
    {
      name: "Porte",
      icon: faUsers,
      roles: ["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"],
      path: "/doors",
      match: "doors",
    },
    {
      name: "Tag",
      icon: faAddressCard,
      submenu: [
        { name: "Gruppi",icon:faUsers, path: "/tag/users", roles: ["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"],disabled:false,match:"tag/users" },
        { name: "Uffici",icon:faTags, path: "/tag/doors", roles: ["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"],disabled:false,match:"tag/doors" },
      ],
      roles: ["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"],
    },
    {
      name: "Storico",
      icon: faArchive,
      roles: ["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"],
      path: "/history",
      match: "history",
    },
  ];

  const { pathname } = window.location;
  const noSidebarPaths = ['/public','/login'];

  const [selectedMenu,setSelectedMenu] = useState('');

  const filteredMenuItems = menuItems.filter(item =>
    item.roles.includes(user.role) 
  );

  const handleOpen = (name) =>{
    if(selectedMenu === name){
      setSelectedMenu('');
    }else{
      setSelectedMenu(name);
    }

  }

  const handleLogout = () => {
    // Logica di logout, per esempio pulizia token o sessione
    console.log("User logged out");
    // Reindirizza alla pagina di login o homepage
    navigate("/login");
    dispatch(resetUser());
  };

  useEffect(() => {
    document.getElementById('content-div').classList.toggle('sidebar-open', isOpen);
    return () => document.getElementById('content-div').classList.remove('sidebar-open');
  }, 
  [isOpen]);


  return (
    noSidebarPaths.includes(pathname)
      ? null
      : (
        <>
        <button
            type="button"
            className="menu-toggle d-block d-sm-none"
            aria-label="Apri/chiudi menu"
            aria-expanded={isOpen}
            onClick={() => setIsOpen(v => !v)}
          >
            ☰
        </button>

          {/* Overlay per chiudere cliccando fuori SMartphone */}
          <div
            className="sidebar-overlay d-sm-none"
            onClick={() => setIsOpen(false)}
          />
          <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark"
                  onClick={(e) => {
            const isLink = e.target.closest('.nav-link');
            if (isLink && window.innerWidth <= 576) setIsOpen(false);
          }}>
            
            <div className="sidebar-logo-container w-100 d-flex justify-content-center">
              <img 
                src={LogoFNMA} 
                alt="Logo FNMA" 
                className="sidebar-logo mb-2" 
              />
            </div>

            
            <div className="sidebar-user d-flex flex-column align-items-center">
              <p className="m-0">{user.username}</p>
            </div>

            <hr className="sidebar-divider my-0" />

            {filteredMenuItems.map((item, index) => (
              <SideMenuItem
                key={index}
                item={item}
                selectedMenu={selectedMenu}
                openMenu={handleOpen}
              />
            ))}

            <hr className="sidebar-divider my-0" />

            <li className="nav-item">
              <div
                className="nav-link"
                onClick={handleLogout}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon className="me-2" icon={faSignOutAlt} />
                <div className="side-menu-text">Logout</div>
              </div>
            </li>
          </ul>



          <ModalContainer />
        </>
      )
  );

}

export default SideMenu